import type { Database } from '@/types/database.types';
type Project = Database['public']['Tables']['projects']['Row'];
type ProjectTeam = Database['public']['Tables']['projects_team']['Row'];
type Member = Database['public']['Tables']['project_members']['Row'];
type ProjectWithTeamAndMembers = Project & {
  projects_team: ProjectTeam;
} & { project_members: Member[] | null };
import { formatDate } from '@/lib/utils';
import MarkdownDisplay from '../../../../components/MarkdownDisplay';

export default function DetailsTab({
  project,
}: {
  project: ProjectWithTeamAndMembers;
}) {
  return (
    <div>
      <h2 className="text-lg mb-4">Project Details</h2>
      <div className="grid grid-cols-[200px_1fr] gap-4 text-base">
        <span className="text-muted-foreground text-sm">Deliver by</span>
        <span>{formatDate(project.due_date)}</span>

        <span className="text-muted-foreground text-sm">Brief</span>
        <MarkdownDisplay content={project.brief} />
      </div>
    </div>
  );
}
